import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

import FormField from "../models/FormField";
import MemberForm from "../models/Form";
const usePotentialForm = () => {
  const [form, setForm] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getForm() {
      try {
        const form = await dataProvider.getList("onboard/subscribe/form", {
          code: "FORM:POTENTIAL:ONBOARD:2.0",
        });

        const fields = form.data.map((d) => new FormField(d));

        setForm(new MemberForm(fields));
        return setLoading(false);
      } catch (error) {
        console.error(error);

        setError(error);
        return setLoading(false);
      }
    }

    setLoading(true);
    getForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { form, loading, error };
};

export default usePotentialForm;
